import { useCallback, useRef } from '@max/max';
const useDebounce = (fn, delay = 500) => {
    const timerRef = useRef(null);
    const debouncedFn = useCallback((...args) => {
        // 清除之前的定时器
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        // 设置新的定时器
        timerRef.current = setTimeout(() => {
            fn(...args);
        }, delay);
    }, [fn, delay]);
    return debouncedFn;
};
export default useDebounce;
